export default {
  image: {
    alt: 'Image showing a person holding a pencil',
    filename:
      '//a.storyblok.com/f/46530/1501x1000/1473d538f3/pexels-edward-jenner-4031818.jpg',
  },
  video: {
    alt: 'Article Video',
    filename: null,
    temp: '//a.storyblok.com/f/46530/x/05859de4bd/hero-003-desk.mp4',
  },
  youtube: {
    url: null,
    temp: 'https://www.youtube.com/watch?v=2CCNswShJRc',
  },
  vimeo: {
    url: null,
    temp: 'https://vimeo.com/343460749',
  },
  component: 'm-article-media',
}
